import * as React from 'react';
import { Paper } from '@mui/material';

export default function SectionCard({ children, sx, ...props }) {
  return (
    <Paper
      {...props}
      sx={{
        p: { xs: 2, md: 2.5 },
        overflow: 'hidden',
        width: '100%',
        ...sx,
      }}
    >
      {children}
    </Paper>
  );
}



